var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightQuot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 211,
    viewBox: "0 0 280 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M151.094 211C214.294 187 279.894 129.4 279.894 72.6C279.894 45.4 261.494 16.6 236.694 0.599964L157.494 62.2L157.494 64.6C177.494 83 198.294 109.4 198.294 129.4C198.294 153.4 175.894 183 146.294 202.2L151.094 211ZM5.4938 211C68.6938 187 135.094 129.4 135.094 72.6C135.094 45.4 115.894 16.6 91.0938 0.599977L12.6938 62.2L12.6938 64.6C31.8938 83 53.4938 109.4 53.4938 129.4C53.4938 153.4 30.2938 183 0.693816 202.2L5.4938 211Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightQuot);
export default __webpack_public_path__ + "static/media/right-quot.e8491f49dc6ec39285eb86bf660f2663.svg";
export { ForwardRef as ReactComponent };